import React from 'react'
import '../../css/testcaseio.scss'

// The input and expected output of a public test case, shown under its name wherever
// students see their test list (see testVisibility.js). Hidden tests never render this.
const TestCaseIO = ({ input, expected }) => (
  <div className="tc-io">
    <div className="tc-io__row">
      <span className="tc-io__label">Input</span>
      <code className="tc-io__value">{input === '' || input == null ? '(none)' : String(input)}</code>
    </div>
    <div className="tc-io__row">
      <span className="tc-io__label">Expected</span>
      <code className="tc-io__value">{expected === '' || expected == null ? '(none)' : String(expected)}</code>
    </div>
  </div>
)

// Next to a hidden test's name, only in lists that also have public tests: says why this
// row has no input / expected output.
export const HiddenTestTag = () => (
  <span className="tc-hidden-tag" title="The input and expected output of this test are hidden">
    Hidden
  </span>
)

// A public check of a Python class exercise: the code that has to come out True.
export const TestCaseCheck = ({ check }) => (
  <div className="tc-io">
    <div className="tc-io__row tc-io__row--stacked">
      <span className="tc-io__label">Check</span>
      <code className="tc-io__value tc-io__code">{check}</code>
    </div>
  </div>
)

// The student-facing cell content for one test: its name (plus the Hidden tag), then the
// example for a public test. `view` is studentTestView(...); `renderName` wraps the name
// in each list's own markup.
export const StudentTestCell = ({ view, renderName = (name) => name }) => (
  <>
    {renderName(
      <>
        {view.name}
        {view.hiddenTag && <HiddenTestTag />}
      </>
    )}
    {!view.hidden &&
      (view.check != null ? <TestCaseCheck check={view.check} /> : <TestCaseIO input={view.input} expected={view.expected} />)}
  </>
)

export default TestCaseIO
